/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
import Cookies from 'universal-cookie';
import { ToasterMessage } from '../components/sharedComponents';

const cookies = new Cookies();
export const customMiddleWare = () => next => action => {
  if (
    action.type !== undefined &&
    action.type !== 'logincall' &&
    action.type !== 'haspendinglogin' &&
    action.type !== 'S3Url' &&
    action.type !== 'errormsg' &&
    action.type !== 'forgetemailsuccessmessage' &&
    action.type !== 'resetmsg' &&
    action.type !== 'reseterrormsg' &&
    cookies.get('token') === undefined
  ) {
    ToasterMessage('error', 'Session has been expired');
    window.location.reload();
  } else {
    next(action);
  }
};
